
import { PaymentsTable } from "components";

const Payments = () => {

    return (
        <PaymentsTable />
    );

}
export default Payments;